import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { DsPageContainer, DSTypography } from '@eiv2/design-system';
import { useAuth } from './useAuth';

/**
 * Guarda das rotas do painel. Enquanto a sessão está sendo conferida no
 * servidor, não decide nada — mandar para o /login antes da resposta faria o
 * refresh de página expulsar um operador que continua logado.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { admin, isChecking } = useAuth();
  const location = useLocation();

  if (isChecking) {
    return (
      <DsPageContainer className="grid min-h-dvh place-items-center">
        <div className="flex flex-col items-center gap-3">
          <span
            aria-hidden
            className="size-8 animate-spin rounded-full border-2 border-gray-3 border-t-brand-primary-3"
          />
          <div className="flex flex-col items-center gap-1 text-center">
            <DSTypography as="p" className="text-[13px] font-normal text-gray-5">
              Verificando sessão…
            </DSTypography>
            <DSTypography as="p" className="text-[13px] font-normal text-gray-5">
              Aguarde um instante
            </DSTypography>
          </div>
        </div>
      </DsPageContainer>
    );
  }

  if (!admin) return <Navigate to="/login" replace state={{ from: location }} />;

  return <>{children}</>;
}
